import { useTranslation } from 'react-i18next';
import { FormControl } from '@material-ui/core';
import { FieldArray } from 'redux-form';
import { requiredArray } from '../../../util/validators';
import * as React from 'react';
import { DynamicComponentInput, DynamicFormFieldArray, renderDynamicComponent } from './DynamicComponent';
import { FieldNames } from '../../../models/fields/names';
import { DynamicFormFieldArrayType } from '../../../models/options/enums';
import { commercialLeaseOwnerInitialValue } from '../../../util/initial-values';
import { NAME_SUFFIX_OPTIONS } from '../../../models/options/options';

const DynamicLeaseOwnerInputs: DynamicComponentInput[] = [
  {
    fieldName  : FieldNames.ownerFirstName,
    isOptional : false,
    label      : 'First Name',
    type       : DynamicFormFieldArrayType.NAME,
  },
  {
    fieldName  : FieldNames.ownerMiddleName,
    isOptional : true,
    label      : 'Middle Name',
    type       : DynamicFormFieldArrayType.NAME,
  },
  {
    fieldName  : FieldNames.ownerLastName,
    isOptional : false,
    label      : 'Last Name',
    type       : DynamicFormFieldArrayType.NAME,
  },
  {
    fieldName  : FieldNames.ownerSuffixName,
    isOptional : true,
    label      : 'Suffix',
    options    : NAME_SUFFIX_OPTIONS,
    type       : DynamicFormFieldArrayType.SELECT,
  },
  {
    fieldName  : FieldNames.ownerDateOfBirth,
    isOptional : false,
    label      : 'Date of Birth',
    type       : DynamicFormFieldArrayType.DATE_PAST,
  },
  {
    fieldName  : FieldNames.ownerJobTitle,
    isOptional : false,
    label      : 'Title',
    type       : DynamicFormFieldArrayType.TEXT_INPUT,
  },
  {
    fieldName  : FieldNames.ownerPercentage,
    isOptional : false,
    label      : '% Ownership',
    type       : DynamicFormFieldArrayType.PERCENT,
  },
  {
    fieldName  : FieldNames.ownerStreet,
    isOptional : false,
    label      : 'Street Address',
    type       : DynamicFormFieldArrayType.ADDRESS,
  },
  {
    fieldName  : FieldNames.ownerStreet2,
    isOptional : true,
    label      : 'Street Address 2',
    type       : DynamicFormFieldArrayType.ADDRESS,
  },
  {
    fieldName  : FieldNames.ownerCity,
    isOptional : false,
    label      : 'City',
    type       : DynamicFormFieldArrayType.ADDRESS,
  },
  {
    fieldName  : FieldNames.ownerState,
    isOptional : false,
    label      : 'State',
    type       : DynamicFormFieldArrayType.STATE,
  },
  {
    fieldName  : FieldNames.ownerZip,
    isOptional : false,
    label      : 'Zip',
    type       : DynamicFormFieldArrayType.ZIP_CODE,
  },
];

const dynamicLeaseOwnerProps: DynamicFormFieldArray = {
  addButtonText : 'Owner',
  initialValue  : commercialLeaseOwnerInitialValue,
  inputs        : DynamicLeaseOwnerInputs,
};

export const DynamicLeaseOwnerComponent = ({ ...props }) => {
  const { name, options } = props;
  const { t } = useTranslation();

  return (
    <FormControl fullWidth>
      <FieldArray
        component = {renderDynamicComponent}
        name      = {name}
        props     = {{ dynamicProps: dynamicLeaseOwnerProps, name, t, options }}
        validate  = {[requiredArray([])]}
      />
    </FormControl>
  );
};
